import { useDroppable } from "@dnd-kit/core";
import PropTypes from "prop-types";

const Droppable = ({ id, path, children }) => {
  const { setNodeRef } = useDroppable({
    id,
    data: { path },
  });
  return <div ref={setNodeRef}>{children}</div>;
};

Droppable.propTypes = {
  id: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default Droppable;
